import { createSelector } from 'reselect';

//
import {
  getIsDeliveryPageInitialisedSelector,
  getShowCollectionHelpSelector,
  getShowPersonalisationMessageSelector,
  getConfirmedDeliveryAddressSelector,
  getDeliveriesSelector,
  getDeliveryOptionsSelector,
  getDeliveryPageApiCallCompleteSelector,
  getPutDeliveryAddressApiCallActiveSelector,
  getSelectedDeliveryChoiceIdSelector,
  getShowClickCollectNowAvailableMessageSelector,
  getUndeliverableItemsInBasketSelector,
  getShowEditBasketModalSelector,
} from '@redux/reducers/delivery/deliverySelector';
import {
  getIsPartnerDiscountProcessingSelector,
  getEligibleForPartnerDiscountSelector,
  getUserIsGuestSelector,
  getUserIsMyJLMemberSelector,
  getPartnerDiscountStatusSelector,
  getSelectedDeliveryAddressSelector,
} from '@redux/reducers/user/userSelector';
import {
  getOrderFormItemsSelector,
} from '@redux/reducers/order-form/orderFormSelector';

export const showLoadingSpinner = createSelector([
  getDeliveryPageApiCallCompleteSelector,
  getSelectedDeliveryAddressSelector,
  getPutDeliveryAddressApiCallActiveSelector,
], (
  getDeliveryPageApiCallComplete,
  selectedDeliveryAddress,
  putDeliveryAddressApiCallActive,
) => {
  return !!(!getDeliveryPageApiCallComplete ||
    (selectedDeliveryAddress && !selectedDeliveryAddress.invalid && putDeliveryAddressApiCallActive));
});

export const showBatchedDeliveries = createSelector([
  getUndeliverableItemsInBasketSelector,
  getDeliveryPageApiCallCompleteSelector,
  getConfirmedDeliveryAddressSelector,
], (
  undeliverableItemsInBasket,
  getDeliveryPageApiCallComplete,
  confirmedDeliveryAddress,
) => {
  return !!(getDeliveryPageApiCallComplete &&
    confirmedDeliveryAddress &&
    undeliverableItemsInBasket?.length === 0);
});

const deliveryState = createSelector([
  getIsDeliveryPageInitialisedSelector,
  getShowCollectionHelpSelector,
  getShowPersonalisationMessageSelector,
  getDeliveriesSelector,
  getDeliveryOptionsSelector,
  getIsPartnerDiscountProcessingSelector,
  getEligibleForPartnerDiscountSelector,
  getUserIsGuestSelector,
  getUserIsMyJLMemberSelector,
  getOrderFormItemsSelector,
  getPartnerDiscountStatusSelector,
  getSelectedDeliveryChoiceIdSelector,
  getShowClickCollectNowAvailableMessageSelector,
  showLoadingSpinner,
  showBatchedDeliveries,
  getShowEditBasketModalSelector,
], (
  isDeliveryPageInitialised,
  showCollectionHelp,
  showPersonalisationMessage,
  deliveries,
  deliveryOptions,
  isPartnerDiscountProcessing,
  eligibleForPartnerDiscount,
  isGuest,
  isMyJLMember,
  items,
  partnerDiscountStatus,
  selectedDeliveryChoiceId,
  showClickCollectNowAvailableMessage,
  showLoadingSpinner,
  showBatchedDeliveries,
  showEditBasketModal,
) => ({
  isDeliveryPageInitialised,
  showCollectionHelp,
  showPersonalisationMessage,
  deliveries,
  deliveryOptions,
  isPartnerDiscountProcessing,
  eligibleForPartnerDiscount,
  isGuest,
  isMyJLMember,
  items,
  partnerDiscountStatus,
  selectedDeliveryChoiceId,
  showClickCollectNowAvailableMessage,
  showLoadingSpinner,
  showBatchedDeliveries,
  showEditBasketModal,
}));

export default deliveryState;
